/**
 * Makes a close copy of a provided object which is distinct and separate, not occupying the same memory reference.
 * Additionally, properties that make up the object which may have been references in the original object are copied.
 * Because of the nature of JSON, some data types such as `Date` do not retain their original representation.
 */
export const cloneObject = <Type>(input: Type): Type => JSON.parse(JSON.stringify(input));
